import { render, staticRenderFns } from "./bookSearch.vue?vue&type=template&id=2b8db94a&"
import script from "./bookSearch.vue?vue&type=script&lang=js&"
export * from "./bookSearch.vue?vue&type=script&lang=js&"
import style0 from "./bookSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports